import backendAPI from './axiosInstance';

/**
 * Fetch all workflows
 */
export const fetchWorkflowsAPI = async () => {
  try {
  const response = await backendAPI.get('/workflows/');
  return response.data;
    
  } catch (error) {
    console.error('❌ Failed to fetch workflows:', error.response?.data || error.message);
    throw error;
  }
};
